import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft, KeyRound } from "lucide-react";
import { api, formatApiError } from "../lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) return toast.error("Mínimo 8 caracteres");
    if (password !== confirm) return toast.error("Las contraseñas no coinciden");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Contraseña actualizada. Inicia sesión.");
      navigate("/login");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Error");
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="min-h-screen grid place-items-center px-6 text-center">
        <div>
          <h1 className="font-serif text-3xl text-white mb-3">Enlace no válido</h1>
          <Link to="/forgot-password" className="text-[#D4AF37]">Solicitar uno nuevo</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <Link to="/login" className="inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-white mb-8">
          <ArrowLeft className="w-4 h-4" /> Volver
        </Link>
        <div className="bg-black/60 backdrop-blur-xl border border-white/10 rounded-2xl p-10">
          <div className="w-12 h-12 rounded-xl border border-[#D4AF37]/40 grid place-items-center mb-6">
            <KeyRound className="w-5 h-5 text-[#D4AF37]" strokeWidth={1.5} />
          </div>
          <h1 className="font-serif text-3xl text-white mb-2">Elige una nueva contraseña</h1>
          <p className="text-zinc-400 text-sm mb-8">Al menos 8 caracteres.</p>

          <form onSubmit={submit} className="space-y-5" data-testid="reset-form">
            <div>
              <label className="text-xs uppercase tracking-[0.24em] text-zinc-500 mb-2 block">Nueva contraseña</label>
              <input
                required
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="reset-password"
                className="w-full bg-transparent border border-white/10 rounded-lg px-4 py-3 text-white focus:border-[#D4AF37] focus:outline-none"
              />
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.24em] text-zinc-500 mb-2 block">Confirmar</label>
              <input
                required
                type="password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                data-testid="reset-confirm"
                className="w-full bg-transparent border border-white/10 rounded-lg px-4 py-3 text-white focus:border-[#D4AF37] focus:outline-none"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              data-testid="reset-submit"
              className="w-full py-3 rounded-full bg-[#D4AF37] text-black font-medium hover:bg-[#FDE047] transition-colors disabled:opacity-60"
            >
              {loading ? "Guardando…" : "Restablecer contraseña"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
